// header-effects.ts

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useHeaderStore } from './header-store';
import { useIsLoggedIn } from '@ekonavi/auth';

export const useHeaderEffects = () => {
	const setHeaderActionButtonText = useHeaderStore((state) => state.setHeaderActionButtonText);
	const setHeaderActionButtonLocation = useHeaderStore((state) => state.setHeaderActionButtonLocation);

	const location = useLocation();
	const isLoggedIn = useIsLoggedIn();

	useEffect(() => {
		resolveHeaderActionButton();
	}, [location.pathname]);

	const resolveHeaderActionButton = () => {
		let text = 'Painel';
		let toLocation = '/painel';
		
		// Check for edit route patterns first
		if (location.pathname.startsWith('/relatorios/editar/')) {
			text = 'Salvar';
			toLocation = '#'; // Will be handled by form
			setHeaderActionButtonText(text);
			setHeaderActionButtonLocation(toLocation);
			return;
		}
		
		if (location.pathname.startsWith('/projetos/editar/')) {
			text = 'Salvar';
			toLocation = '#'; // Will be handled by form
			setHeaderActionButtonText(text);
			setHeaderActionButtonLocation(toLocation);
			return;
		}
		
		switch (location.pathname) {
			case '/auth':
				text = 'Início';
				toLocation = '/';
				break;
			case '/painel':
				text = 'Gerenciar Dados';
				toLocation = '/relatorios';
				break;
			case '/projetos':
				text = 'Criar Projeto';
				toLocation = '/projetos/criar';
				break;
			case '/relatorios':
				text = 'Criar Relatório';
				toLocation = '/relatorios/criar';
				break;
			case '/relatorios/criar':
				text = 'Salvar';
				toLocation = '#'; // Will be handled by form
				break;
			case '/projetos/criar':
				text = 'Salvar';
				toLocation = '#'; // Will be handled by form
				break;
			case '/':
			default:
				text = isLoggedIn ? 'Painel' : 'Login';
				toLocation = isLoggedIn ? '/painel' : '/auth';
				break;
		}
		setHeaderActionButtonText(text);
		setHeaderActionButtonLocation(toLocation);
	};
};
